var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowLeft(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 35.1 23"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.9 13.3l.5.5c1.9 2 3.8 4 5.8 6.1.9 1 .8 2.3-.3 2.9-.7.4-1.5.3-2.2-.4-1.3-1.4-2.7-2.8-4-4.2-1.7-1.8-3.3-3.5-5-5.3-.8-.9-.8-1.9 0-2.7C3.7 7 6.8 3.9 9.8.7c.8-.8 1.8-.9 2.6-.1.6.6.6 1.6-.2 2.5l-6 6.3c-.1 0-.1.1-.3.3h21.7c1 0 1.6.4 1.9 1.2.4 1.1-.4 2.2-1.5 2.3H6.1c-.1.1-.1.1-.2.1zM31.6 11.5V1.8c0-.8.4-1.4 1.1-1.7.7-.3 1.4-.1 1.9.5.4.4.5.8.5 1.3V21.2c0 .8-.4 1.3-1.1 1.6-.7.3-1.3.2-1.9-.3-.4-.4-.6-.8-.6-1.4.1-3.2.1-6.4.1-9.6z"
  })));
}
export default SvgArrowLeft;